
if( $('#modal-meus-filtros').length ) {

    var vmMeusFiltros = new Vue({
        el: '#modal-meus-filtros',
        data: {
            tipo                : '', // 'questoes' ou 'provas'
            meusFiltros         : [],
            meuFiltroSelecionado: -1,
            nomeMeuFiltro       : null,
            carregando          : false,
            titulo              : '',
            lightbox            : lity()
        },
        methods: {
            abrirModal: function ( tipo ) {

                var self = this;
                this.tipo = tipo;
                this.meusFiltros = [];
                this.meuFiltroSelecionado = -1;
                this.nomeMeuFiltro = null;

                this.titulo = (tipo == 'questoes') ? 'Meus Filtros de Questões' : 'Meus Filtros de Provas';

                /* Abre o modal */
                this.carregando = true;
                this.lightbox('#modal-meus-filtros');

                ajaxGET(
                    '/filtros/lista-filtros-usuario',
                    { tipo: this.tipo },
                    function (retorno) {
                        self.meusFiltros = retorno;
                        self.carregando = false;
                    }
                );

            },
            carregarFiltro: function () {

                if (this.meuFiltroSelecionado == -1) {
                    return false;
                }

                this.lightbox.close();

                ajaxGET(
                    '/filtros/carrega-filtro-usuario',
                    { filtroId: this.meuFiltroSelecionado },
                    this.carregarFiltroSucesso
                );

            },
            carregarFiltroSucesso: function (dados) {

                var vm = (this.tipo == 'questoes') ? vmQuestoes : vmProvas;

                vm.suspendeWatchs = true;

                for (var filtro in dados.filtros) {
                    if (filtro == 'palavras') {
                        vm.filtros[filtro].opcoes = dados.filtros[filtro];
                    }
                    vm.filtros[filtro].selecionados = dados.filtros[filtro];
                }

                for (var mo in dados.maisopcoes) {
                    vm.maisopcoes.opcoes[mo].valor = true;
                }

                /* Só filtros de questões tem qpp */
                if( dados.qpp ){
                    vm.questoesPorPag = dados.qpp;
                }

                Vue.nextTick(function () {
                    vm.suspendeWatchs = false;
                });

                flash('Filtro Carregado com Sucesso!', 'sucesso');
            },
            excluirFiltro: function () {

                if (this.meuFiltroSelecionado == -1) {
                    return false;
                }

                this.lightbox.close();

                confirma(
                    'Deseja mesmo excluir este filtro?',
                    vmMeusFiltros.exclusaoFiltroConfirmada
                );
            },
            exclusaoFiltroConfirmada: function () {

                ajaxPOST(
                    '/filtros/exclui-filtro-usuario',
                    { filtroId: this.meuFiltroSelecionado }
                );
            },
            novoFiltro: function () {

                if (!this.nomeMeuFiltro) {
                    return -1;
                }

                this.lightbox.close();

                var filtrosAtivos = this.recuperaFiltrosAtivos();

                ajaxPOST(
                    '/filtros/salva-filtro-usuario',
                    {
                        nomefiltro  : this.nomeMeuFiltro,
                        tipo        : this.tipo,
                        filtros     : JSON.stringify(filtrosAtivos)
                    }
                );

            },
            recuperaFiltrosAtivos: function () {

                var vm = (this.tipo == 'questoes') ? vmQuestoes : vmProvas;

                var filtro;
                var dados = {filtros: {}, maisopcoes: {}};
                for (var i in vm.filtros) {
                    filtro = vm.filtros[i];
                    if (filtro.hasOwnProperty('selecionados')) {
                        if (filtro.selecionados.length) {
                            dados.filtros[i] = filtro.selecionados;
                        }
                    }
                }

                /* Tem alguma "Mais Opções" selecionada? */
                if (vm.totalMaisOpcoesAtivas > 0) {
                    for (var i in vm.maisopcoes.opcoes) {
                        if (vm.maisopcoes.opcoes[i].valor) {
                            dados.maisopcoes[i] = 1;
                        }
                    }
                }

                if( this.tipo == 'questoes' ){
                    dados.qpp = vmQuestoes.questoesPorPag;
                }

                return dados;
            }
        }
    });

}